const PROVIDER_DISPLAY_NAMES = {
  evoplay: "Evoplay",
  bgaming: "BGaming",
  tadagaming: "Tada Game",
  tada: "Tada Game",
  evolution: "Evolution",
  evolutiongaming: "Evolution",
  evolutiongaming__hub88: "Evolution",
  pragmatic: "Pragmatic Play",
  kagaming: "KA Gaming",
  kaga: "KA Gaming",
  upgaming: "Up Gaming",
  hacksaw: "Hacksaw Gaming",
  gamingcorps: "Gaming Corps",
  pixmove: "Pix Move",
};

export const getProviderDisplayName = code => PROVIDER_DISPLAY_NAMES[code?.toLowerCase()] ?? code;

// Strips the "__<aggregator>" suffix from a provider slug so the backend's
// ResolveActiveProviderBySlug can pick the active aggregator. Avoids sending
// "evolutiongaming__hub88" (which may be the disabled row) when the canonical
// short slug "evolutiongaming" would route to the active sibling.
export const getProviderBaseSlug = slug => {
  if (!slug) return slug;
  const idx = slug.lastIndexOf("__");
  return idx >= 0 ? slug.slice(0, idx) : slug;
};
